export enum ButtonTypes {
  CTA = 'CTA',
  Outline = 'OUTLINE',
  Danger = 'DANGER',
  Light = 'LIGHT',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIIARY',
  Quaternary = 'QUATERNARY',
  Quinary = 'QUINARY',
  Senary = 'SENARY',
  Septenary = 'SEPTENARY',
  SctecPrimary = 'SCTEC_PRIMARY',
  SctecOutline = 'SCTEC_OUTLINE'

  // no style defined yet for the following types
  // Octonary = 'OCTONARY',
  // Nonary = 'NONARY',
  // Denary = 'DENARY'
}
